export const requistionStatusOption = {
  value: {
    Open: "1",
    Reopened: "2",
    Closed: "3",
  },
  list: [
    {
      label: "Open",
      value: "1",
    },
    {
      label: "Re-opened",
      value: "2",
    },
    {
      label: "Closed",
      value: "3",
    },
  ],
  text: {
    1: "Open",
    2: "Re-opened",
    3: "Closed",
  },
};

export const candidateStatusOption = {
  value: {
    Selected: 2,
    Shortlisted: 3,
    Not_Selected: 4,
    On_Hold: 5,
    No_Show: 6,
    Withdrew: 7,
    Pre_Screened: 8,
    Rescheduled: 9,
    Joined: 10,
  },
  list: [
    // {
    //   value: 1,
    //   label: "Round 1",
    // },
    { value: 2, label: "Selected" },
    { value: 3, label: "Shortlisted" },
    { value: 4, label: "Not Selected" },
    { value: 5, label: "On Hold" },
    { value: 6, label: "No Show" },
    { value: 7, label: "Withdrew" },
    { value: 8, label: "Pre-Screened" },
    { value: 9, label: "Rescheduled" },
    { value: 10, label: "Joined" },
  ],
  text: {
    // 1: "Round 1", // Uncomment if needed
    2: "Selected",
    3: "Shortlisted",
    4: "Not Selected",
    5: "On Hold",
    6: "No Show",
    7: "Withdrew",
    8: "Pre-Screened",
    9: "Rescheduled",
    10: "Joined",
  },
  emailtext: {
    // 1: "Round 1", // Uncomment if needed
    2: "Selected",
    3: "Shortlisted",
    4: "Not Selected",
    5: "On Hold",
    6: "No Show",
    7: "Withdrew",
    8: "Pre-Screened",
    9: "Rescheduled",
    10: "Joined",
  },
  stepperClass: {
    // 1: "Round 1", // Uncomment if needed
    2: "selected",
    3: "shortlisted",
    4: "not-selected",
    5: "on-hold",
    6: "np-show",
    7: "withdrew",
    8: "pre-screened",
    9: "rescheduled",
    10: "joined",
  },
  emailstatusmessage: {
    // 1: "Round 1", // Uncomment if needed
    2: "Please wait for next update from Intelegain HR Team.",
    3: "Please wait for next update from Intelegain HR Team.",
    4: "We encourage you to apply for the future opportunities. Please follow us on LinkedIn for latest updates.",
    5: "We are reviewing other candidates for the same position. Please connect with HR Team after 15 working days.",
    6: "No Show",
    7: "Withdrew",
    8: "Pre-Screened",
    9: "Rescheduled",
    10: "Joined",
  },
};

export const candidateLocationOption = {
  list: [
    {
      value: 1,
      label: "Nerul, Navi Mumbai",
    },
    {
      value: 2,
      label: "Airoli, Navi Mumbai",
    },
    {
      value: 3,
      label: "Ghansoli, Navi Mumbai",
    },
    {
      value: 4,
      label: "Vashi, Navi Mumbai",
    },
    {
      value: 5,
      label: "Belapur CBD, Navi Mumbai",
    },
  ],
};

export const candidateNoticePeriodOption = {
  list: [
    {
      value: "1",
      label: "Immediate Joiner",
    },
    {
      value: "2",
      label: "Currently Serving Notice Period",
    },
    {
      value: "3",
      label: "15 Days",
    },
    {
      value: "4",
      label: "30 Days",
    },
    {
      value: "5",
      label: "45 Days",
    },
    {
      value: "6",
      label: "60 Days",
    },
    {
      value: "7",
      label: "90 Days",
    },
  ],
  text: {
    1: "Immediate Joiner",
    2: "Currently Serving Notice Period",
    3: "15 Days",
    4: "30 Days",
    5: "45 Days",
    6: "60 Days",
    7: "90 Days",
  },
};

export const candidateSourceOption = {
  list: [
    {
      value: "1",
      label: "Job Boards",
    },
    {
      value: "2",
      label: "Website",
    },
    {
      value: "3",
      label: "Social Media",
    },
    {
      value: "4",
      label: "Referral",
    },
  ],
  text: {
    1: "Job Boards",
    2: "Website",
    3: "Social Media",
    4: "Referral",
  },
};

export const departmentOption = {
  list: [
    {
      value: "1",
      label: "Marketing",
    },
    {
      value: "2",
      label: "Accounts",
    },
    {
      value: "3",
      label: "BD/Sales",
    },
    {
      value: "4",
      label: "IT Support",
    },
    {
      value: "5",
      label: "Operations",
    },
    {
      value: "6",
      label: "HR",
    },
    {
      value: "7",
      label: "CRM",
    },
    {
      value: "8",
      label: "BC/NAV",
    },
    {
      value: "9",
      label: "Software Development",
    },
    {
      value: "10",
      label: "UI",
    },
  ],
  text: {
    1: "Marketing",
    2: "Accounts",
    3: "Sales",
    4: "IT",
    5: "Operations",
    6: "HR",
    7: "CRM",
    8: "BC/NAV",
    9: "Software Development",
    10: "UI",
  },
};

export const requisitionByOption = {
  list: [
    {
      value: "1",
      label: "Kapil Chopra",
    },
    {
      value: "2",
      label: "Neeraj Gargi",
    },
    {
      value: "3",
      label: "Aslam Siddiqui",
    },
    {
      value: "4",
      label: "Shalini Chopra",
    },
    {
      value: "5",
      label: "Namrata Sehgal",
    },
  ],
};

export const assignedToOption = {
  list: [
    { value: "1", label: "Shyamali More" },
    { value: "2", label: "Karishma Singh" },
    { value: "3", label: "Jaysri Subbaih" },
    { value: "4", label: "Sharanya Karthik" },
  ],
};

export const requisitionList = [
  {
    id: "1a2b3c4d-5678-9abc-def0-1234567890ab",
    date: "08/01/24",
    jobTitle: "SEO analysis",
    openings: "04",
    relExp: "4 to 5 years",
    budget: "3-5 LPA",
    skillSet:
      "Keyword research, Communication, Link building, SEO trends, SEO techniques",
    requisitionBy: "Kapil Chopra",
  },
  {
    id: "2b3c4d5e-6789-0abc-def1-2345678901bc",
    date: "07/01/24",
    jobTitle: "Accounts Executive",
    openings: "02",
    relExp: "3 to 5 years",
    budget: "5-7 LPA",
    skillSet:
      "Time management, Collaboration, Organisational skills, Organisational awareness",
    requisitionBy: "Kapil Chopra",
  },
  {
    id: "3c4d5e6f-7890-1abc-def2-3456789012cd",
    date: "06/01/24",
    jobTitle: "Sales Manager",
    openings: "01",
    relExp: "4 to 5 years",
    budget: "10-12 LPA",
    skillSet:
      "Sales forecasting, Sales planning, Coaching, Analyzing sales, Sales strategy",
    requisitionBy: "Neeraj Gargi",
  },
  {
    id: "4d5e6f7g-8901-2abc-def3-4567890123de",
    date: "05/01/24",
    jobTitle: "DevOps Engineer",
    openings: "02",
    relExp: "5 to 6 years",
    budget: "11-14 LPA",
    skillSet:
      "Containerization, Security, Coding and scripting, Adaptability, Coding standards",
    requisitionBy: "Namrata Sehgal",
  },
  {
    id: "5e6f7g8h-9012-3abc-def4-5678901234ef",
    date: "04/01/24",
    jobTitle: "Project Manager",
    openings: "04",
    relExp: "4 to 5 years",
    budget: "15-18 LPA",
    skillSet:
      "Project Management, Problem solving, Time management, Time analysis",
    requisitionBy: "Aslam Siddiqui",
  },
  {
    id: "6f7g8h9i-0123-4abc-def5-6789012345fg",
    date: "03/01/24",
    jobTitle: "Talent Acquisition",
    openings: "05",
    relExp: "5 to 6 years",
    budget: "3-5 LPA",
    skillSet:
      "Multitasking, Marketing skills, Developing relationships, Developing talent",
    requisitionBy: "Shalini Chopra",
  },
  {
    id: "7g8h9i0j-1234-5abc-def6-7890123456gh",
    date: "02/02/24",
    jobTitle: "Senior Accounts Executive",
    openings: "01",
    relExp: "8 to 10 years",
    budget: "10-12 LPA",
    skillSet: "Time management, Account management, Account analysis",
    requisitionBy: "Shalini Chopra",
  },
  {
    id: "8h9i0j1k-2345-6abc-def7-8901234567hi",
    date: "01/02/24",
    jobTitle: "Content Writer",
    openings: "01",
    relExp: "5 to 6 years",
    budget: "5-7 LPA",
    skillSet:
      "Content creation, Communication, Time management, Content writing",
    requisitionBy: "Namrata Sehgal",
  },
  {
    id: "9i0j1k2l-3456-7abc-def8-9012345678ij",
    date: "30/01/24",
    jobTitle: "Content Writer",
    openings: "01",
    relExp: "5 to 6 years",
    budget: "4-6 LPA",
    skillSet:
      "Content creation, Communication, Time management, Time management analysis",
    requisitionBy: "Kapil Chopra",
  },
  {
    id: "9i0j1k2l-3456-7abc-def8-9012345678iz",
    date: "30/01/24",
    jobTitle: "Content Writer",
    openings: "01",
    relExp: "5 to 6 years",
    budget: "4-6 LPA",
    skillSet:
      "Content creation, Communication, Time management, Time management analysis",
    requisitionBy: "Kapil Chopra",
  },
  {
    id: "9i0j1k2l-3456-7abc-def8-9012345678iy",
    date: "30/01/24",
    jobTitle: "Content Writer",
    openings: "01",
    relExp: "5 to 6 years",
    budget: "4-6 LPA",
    skillSet:
      "Content creation, Communication, Time management, Time management analysis",
    requisitionBy: "Namrata Sehgal",
  },
  {
    id: "9i0j1k2l-3456-7abc-def8-9012345678iw",
    date: "30/01/24",
    jobTitle: "Content Writer",
    openings: "01",
    relExp: "5 to 6 years",
    budget: "4-6 LPA",
    skillSet:
      "Content creation, Communication, Time management, Time management analysis",
    requisitionBy: "Namrata Sehgal",
  },
];

export const singleRequisitionList = [
  {
    id: "c1f8d5d3-cc84-4d49-8f74-b5f8d9dce621",
    date: "08/01/24",
    name: "Henry Higgins",
    number: "1234567890",
    totalExp: "5.6 yrs",
    relExp: "3.6 yrs",
    cctc: "2 LPA",
    ectc: "4-5 LPA",
    np: "30 days",
    location: "Ghansoli Navi,Mumbai",
    status: {
      code: "R1",
      icon: "minus",
    },
  },
  {
    id: "e1e0d31d-7e98-4874-9508-4d4e0f5824f6",
    date: "08/01/24",
    name: "Hazel Nutt",
    number: "1234567890",
    totalExp: "5.6 yrs",
    relExp: "3.6 yrs",
    cctc: "2 LPA",
    ectc: "4-5 LPA",
    np: "30 days",
    location: "CBD Belapur Navi,Mumbai",
    status: {
      code: "OH",
      icon: "circle",
    },
  },
  {
    id: "9e2ae8a1-e0e3-4b8e-a716-0220bc6fae1d",
    date: "08/01/24",
    name: "Marsha Mellow",
    number: "1234567890",
    totalExp: "5.6 yrs",
    relExp: "3.6 yrs",
    cctc: "2 LPA",
    ectc: "4-5 LPA",
    np: "30 days",
    location: "Nerul Navi,Mumbai",
    status: {
      code: "SH",
      icon: "minus",
    },
  },
  {
    id: "60a27a9d-b4a2-4e53-87b5-846b70de3f7b",
    date: "08/01/24",
    name: "Paige Turner",
    number: "1234567890",
    totalExp: "5.6 yrs",
    relExp: "3.6 yrs",
    cctc: "2 LPA",
    ectc: "4-5 LPA",
    np: "30 days",
    location: "CBD Belapur Navi,Mumbai",
    status: {
      code: "RE",
      icon: "minus",
    },
  },
  {
    id: "9348a65c-b91a-493a-bbf6-0481959a9a34",
    date: "08/01/24",
    name: "Anne Teak",
    number: "1234567890",
    totalExp: "5.6 yrs",
    relExp: "3.6 yrs",
    cctc: "2 LPA",
    ectc: "4-5 LPA",
    np: "30 days",
    location: "Nerul Navi,Mumbai",
    status: {
      code: "S",
      icon: "circle",
    },
  },
  {
    id: "f5f09347-c951-4e7d-b3e6-d5a56803d645",
    date: "08/01/24",
    name: "Anita Bath",
    number: "1234567890",
    totalExp: "5.6 yrs",
    relExp: "3.6 yrs",
    cctc: "2 LPA",
    ectc: "4-5 LPA",
    np: "30 days",
    location: "Nerul Navi,Mumbai",
    status: {
      code: "W",
      icon: "minus",
    },
  },
  {
    id: "bcf4f1ae-d887-4da5-97d8-d19fb4b21295",
    date: "08/01/24",
    name: "Paige Turner",
    number: "1234567890",
    totalExp: "5.6 yrs",
    relExp: "3.6 yrs",
    cctc: "2 LPA",
    ectc: "4-5 LPA",
    np: "30 days",
    location: "CBD Belapur Navi,Mumbai",
    status: {
      code: "NS",
      icon: "circle",
    },
  },
  {
    id: "7aa4e8a2-7c56-4b80-bf41-5d2d98f6b6df",
    date: "08/01/24",
    name: "John Smith",
    number: "9876543210",
    totalExp: "4.0 yrs",
    relExp: "2.5 yrs",
    cctc: "3 LPA",
    ectc: "5-6 LPA",
    np: "60 days",
    location: "Thane, Mumbai",
    status: {
      code: "A1",
      icon: "check",
    },
  },
  {
    id: "b3877b8c-92ae-4e75-a7b3-23894d9483f8",
    date: "08/01/24",
    name: "Jessica Stone",
    number: "9991112223",
    totalExp: "7.2 yrs",
    relExp: "5.0 yrs",
    cctc: "6 LPA",
    ectc: "8-9 LPA",
    np: "45 days",
    location: "Vashi Navi,Mumbai",
    status: {
      code: "P2",
      icon: "circle",
    },
  },
  {
    id: "927d76cb-e26c-4527-b5e6-72f0d6937e4d",
    date: "08/01/24",
    name: "Max Power",
    number: "8883335555",
    totalExp: "10.0 yrs",
    relExp: "7.0 yrs",
    cctc: "8 LPA",
    ectc: "10-12 LPA",
    np: "90 days",
    location: "Powai, Mumbai",
    status: {
      code: "P1",
      icon: "minus",
    },
  },
];

export const noticePeriod = {
  list: [
    { label: "Immediate Joiner", value: "1" },
    { label: "15 Days", value: "3" },
    { label: "30 Days", value: "4" },
    { label: "1 Month", value: "5" },
    { label: "2 Months", value: "6" },
    { label: "3 Months", value: "7" },
    { label: "Currently Serving Notice Period", value: "2" },
  ],
};

export const cctcAndEctc = [
  {
    label: "Upto 5L",
    value: 1,
  },
  {
    label: "5 - 10L",
    value: 2,
  },
  {
    label: "10 - 15L",
    value: 3,
  },
  {
    label: "15 - 20L",
    value: 4,
  },
  {
    label: "Above 20L",
    value: 5,
  },
];

export const candidatesStatusList = {
  list: [
    // {
    //   borderText: "#4d7cfe",
    //   shortLabel: "R1",
    //   label: "Round 1",
    //   background: "#eef3ff",
    //   value: 1,
    // },
    {
      borderText: "#FFFFFF",
      shortLabel: "S",
      label: "Selected",
      background: "#07bc37",
      value: 2,
    },
    {
      borderText: "#FFFFFF",
      shortLabel: "SH",
      label: "Shortlisted",
      background: "#096fea",
      value: 3,
    },
    {
      borderText: "#FFFFFF",
      shortLabel: "RE",
      label: "Not Selected",
      background: "#de0500",
      value: 4,
    },
    {
      borderText: "#FFFFFF",
      shortLabel: "OH",
      label: "On hold",
      background: "#7d7d7d",
      value: 5,
    },
    {
      borderText: "#FFFFFF",
      shortLabel: "NS",
      label: "No show",
      background: "#e26315",
      value: 6,
    },
    {
      borderText: "#FFFFFF",
      shortLabel: "W",
      label: "Withdraw candidate",
      background: "#0C4A6E",
      value: 7,
    },
    {
      borderText: "#FFFFFF",
      shortLabel: "PS",
      label: "Pre Screened",
      background: "#9a59b5",
      value: 8,
    },
    {
      borderText: "#FFFFFF",
      shortLabel: "RS",
      label: "Rescheduled",
      background: "#7e0a73",
      value: 9,
    },
    {
      borderText: "#FFFFFF",
      shortLabel: "J",
      label: "Joined",
      background: "#12522A",
      value: 10,
    },
  ],
  value: {
    RoundOne: 1,
    Selected: 2,
    Shortlisted: 3,
    Rejected: 4,
    OnHold: 5,
    NOShow: 6,
    WithdrawCandidates: 7,
    Rescheduled: 9,
  },
  statusBadge: {
    // 1: {
    //   borderText: "#4d7cfe",
    //   shortLabel: "R1",
    //   label: "Round 1",
    //   background: "#eef3ff",
    //   value: 1,
    // },
    2: {
      borderText: "#007A4D",
      shortLabel: "S",
      label: "Selected",
      background: "#D1F4DF",
      value: 2,
    },
    3: {
      borderText: "#DC910B",
      shortLabel: "SH",
      label: "Shortlisted",
      background: "#FBEEDA",
      value: 3,
    },
    4: {
      borderText: "#FB1C24",
      shortLabel: "RE",
      label: "Not Selected",
      background: "#FEE3EB",
      value: 4,
    },
    5: {
      borderText: "#7D7D7D",
      shortLabel: "OH",
      label: "On hold",
      background: "#DADADA",
      value: 5,
    },
    6: {
      borderText: "#9747FF",
      shortLabel: "NS",
      label: "No show",
      background: "#E7D4FF",
      value: 6,
    },
    7: {
      borderText: "#E97642",
      shortLabel: "W",
      label: "Withdraw candidate",
      background: "#FFE3DB",
      value: 7,
    },
    8: {
      borderText: "#d4c623",
      shortLabel: "PS",
      label: "Pre Screened",
      background: "rgba(212, 197, 35, 0.13)",
      value: 8,
    },
    9: {
      borderText: "#d4c623",
      shortLabel: "RS",
      label: "Rescheduled",
      background: "#7e0a73",
      value: 9,
    },
    10: {
      borderText: "#FFFFFF",
      shortLabel: "J",
      label: "Joined",
      background: "#00d084",
      value: 10,
    },
  },
};

export const locationListOption = [
  {
    label: "Nerul, Navi Mumbai",
    value: "0",
  },
  {
    label: "Airoli, Navi Mumbai",
    value: "0",
  },
  {
    label: "Vashi, Navi Mumbai",
    value: "0",
  },
  {
    label: "Ghansoli, Navi Mumbai",
    value: "0",
  },
];

export const modeList = {
  list: [
    { label: "Virtual", value: 1 },
    { label: "In Person", value: 2 },
  ],
  value: { VirtualInterview: 1, inPerson: 2 },
  text: { 1: "Virtual Interview", 2: "In Person" },
  popup: { 1: "Teams Meeting", 2: "In Person" },
};

export const skillSetExperience = {
  list: [
    { value: 1, label: "0 - 1" },
    { value: 2, label: "1 - 2" },
    { value: 3, label: "2 - 3" },
    { value: 4, label: "3 - 4" },
    { value: 5, label: "4 - 5" },
    { value: 6, label: "5 - 6" },
    { value: 7, label: "6 - 7" },
    { value: 8, label: "7 - 8" },
    { value: 9, label: "8+" },
  ],
  text: {
    1: "0 - 1",
    2: "1 - 2",
    3: "2 - 3",
    4: "3 - 4",
    5: "4 - 5",
    6: "5 - 6",
    7: "6 - 7",
    8: "7 - 8",
    9: "8+",
  },
};

export const employmentType = {
  list: [
    { label: "Permanent", value: 1 },
    { label: "Contract", value: 2 },
  ],
  value: { Permanent: 1, Contract: 2 },
  text: { 1: "Permanent", 2: "Contract" },
};

export const familyDetailRelation = {
  list: [
    { label: "Father", value: 1 },
    { label: "Mother", value: 2 },
    { label: "Brother", value: 3 },
    { label: "Sister", value: 4 },
    { label: "Spouse", value: 5 },
    { label: "Son", value: 6 },
    { label: "Daughter", value: 7 },
  ],
  text: {
    1: "Father",
    2: "Mother",
    3: "Brother",
    4: "Sister",
    5: "Spouse",
    6: "Son",
    7: "Daughter",
  },
};

export const reference = {
  list: [
    { label: "Professional", value: 1 },
    { label: "Personal", value: 2 },
  ],
  text: {
    1: "Professional",
    2: "Personal",
  },
};

export const applicantStatus = {
  list: [
    { label: "Screen Reject", value: 0 },
    { label: "Qualified", value: 1 },
  ],
  text: {
    0: "Screen Reject",
    1: "Qualified",
  },
  value: { "Screen Reject": 0, "Qualified": 1 },
};
